import axios from '../../../axios';
import { InformationReqResponse } from '../types/InformationReqResponse';
import { SendRequestPayload, UpdateRTRRequestPayload } from '../types/RtrRequestPayload';

const url = 'corphiringservice/api/information-req-response';

export const getAllResponses = (
  interactionId: string,
  jobId: string,
  recruiterEmail: string,
  teamId?: string
) =>
  axios.get(`${url}`, {
    params: {
      interactionId,
      jobId,
      recruiterEmail,
      teamId,
    },
  });

export const sendInformationReq = (payload: SendRequestPayload) =>
  axios.post(`${url}/send-request`, payload);

export const getInformationReqResponse = (id: string) => axios.get(`${url}/id/${id}`);

export const saveInformationReqResponse = (body: InformationReqResponse) =>
  axios.post(`${url}/response`, body);

export const getInformationRequestByInteractionId = (interactionId: string) =>
  axios.get(`${url}/getInteractionIdAndRtrFeedback?interactionId=${interactionId}`);

export const updateRTRfeedback = (payload: UpdateRTRRequestPayload) =>
  axios.post(`${url}/updateRTRfeedback`, payload);

export const getRtrPdfs = (candidateId: string) => axios.get(`${url}/getrtrpdfs/${candidateId}`);

export const getCandidateDocuments = (candidateId: string) =>
  axios.get(`${url}/getcandidatedocs/${candidateId}`);

export const updateCandidateForInfoRequestDocs = (
  existingCandidateId: string,
  newCandidateId: string
) => axios.put(`${url}/updatedocscandidate/`, { existingCandidateId, newCandidateId });
